import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

const navItems = [
  { label: 'BACK', href: '/' },
  { label: 'HOME', href: '#hero' },
  { label: 'ABOUT', href: '#about' },
  { label: 'WINNERS', href: '#winners-glance' },
  { label: 'DOCUMENTATION', href: '#documentation' },
  { label: 'CONTACTS', href: '#contacts' },
];

export default function TopNav({ visible, logos = {} }) {
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const media = window.matchMedia('(min-width: 768px)');
    const handleChange = () => { if (media.matches) setMenuOpen(false); };
    handleChange();
    media.addEventListener('change', handleChange);
    return () => media.removeEventListener('change', handleChange);
  }, []);

  const handleClick = (e, href) => {
    if (href.startsWith('#')) {
      e.preventDefault();
      const el = document.querySelector(href);
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    }
    setMenuOpen(false);
  };

  const imgCls = 'w-8 h-8 max-[899px]:w-[1.5rem] max-[899px]:h-[1.5rem] navbar-compact:w-10 navbar-compact:h-10 object-contain';
  const hasLogo = logos.himstat || logos.ihmsi || logos.spss;

  return (
    <>
      <nav
        id="spss-topnav"
        className={`fixed top-0 left-0 right-[18px] z-50 flex items-center justify-between px-4 tablet:px-8 desktop:px-12 py-3 transition-all duration-500 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 -translate-y-full pointer-events-none'}`}
        style={{
          background: 'linear-gradient(180deg, rgba(52,86,146,0.85) 0%, rgba(74,116,184,0.78) 48%, rgba(56,96,154,0.84) 100%)',
          backdropFilter: 'blur(14px)',
          boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.08), 0 6px 24px rgba(0,0,25,0.35)',
        }}
      >
        <div className="hidden tablet:flex items-center gap-4 max-[899px]:gap-1.5 large-desktop:gap-5 flex-wrap">
          {navItems.map((item) =>
            item.href.startsWith('/') ? (
              <Link key={item.label} to={item.href} className="spss-pill">
                <span className="spss-pill-label">
                  {item.label === 'BACK' && <i className="fa-solid fa-chevron-left" aria-hidden="true" />}
                  {item.label}
                </span>
              </Link>
            ) : (
              <a key={item.label} href={item.href} className="spss-pill" onClick={(e) => handleClick(e, item.href)}>
                <span className="spss-pill-label">
                  {item.label === 'BACK' && <i className="fa-solid fa-chevron-left" aria-hidden="true" />}
                  {item.label}
                </span>
              </a>
            )
          )}
        </div>

        <button
          type="button"
          aria-label="Open navigation menu"
          onClick={() => setMenuOpen(true)}
          className="tablet:hidden flex items-center justify-center w-10 h-10 text-white text-2xl leading-none"
        >
          <i className="fa-solid fa-bars" />
        </button>

        {hasLogo && (
          <div
            className="flex items-center gap-2 navbar-compact:gap-3 border-4 border-[#245294] rounded-md px-2.5 navbar-compact:px-3.5 py-2"
            style={{ visibility: visible ? 'visible' : 'hidden', background: 'linear-gradient(90deg, #ffffff 0%, #cde3f9 50%, #9ec8f0 100%)' }}
          >
            {logos.himstat && <img src={logos.himstat} alt="HIMSTAT" className={imgCls} />}
            {logos.ihmsi && <img src={logos.ihmsi} alt="IHMSI" className={imgCls} />}
            {logos.spss && <img src={logos.spss} alt="SPSS" className={`${imgCls} rounded`} />}
          </div>
        )}
      </nav>

      <div
        className={`fixed top-0 right-[18px] bottom-0 z-[60] flex flex-col py-6 transition-transform duration-300 ${menuOpen ? 'translate-x-0' : 'translate-x-full pointer-events-none'}`}
        style={{
          width: 'min(68vw, 220px)',
          height: '100vh',
          background: 'linear-gradient(180deg, rgba(110,160,220,0.28) 0%, rgba(150,190,235,0.3) 50%, rgba(120,170,225,0.26) 100%)',
          backdropFilter: 'blur(12px)',
          WebkitBackdropFilter: 'blur(12px)',
          borderLeft: '1px solid rgba(190,220,255,0.3)',
          boxShadow: 'inset 0 0 30px rgba(180,215,255,0.08), 0 0 24px rgba(120,180,255,0.12)',
        }}
      >
        <div className="relative flex items-center justify-between px-5 pb-2">
          <span className="spss-section-subtitle">MENU</span>
          <button type="button" aria-label="Close navigation menu" onClick={() => setMenuOpen(false)} className="text-white text-xl leading-none">
            <i className="fa-solid fa-xmark" />
          </button>
        </div>
        <div className="relative flex flex-col gap-3 px-5 mt-2 overflow-y-auto spss-custom-scrollbar">
          {navItems.map((item) =>
            item.href.startsWith('/') ? (
              <Link key={item.label} to={item.href} className="spss-nav-btn" onClick={() => setMenuOpen(false)}>{item.label}</Link>
            ) : (
              <a key={item.label} href={item.href} className="spss-nav-btn" onClick={(e) => handleClick(e, item.href)}>{item.label}</a>
            )
          )}
        </div>
      </div>
    </>
  );
}
